import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';
import { hexToRgbA } from 'utils/styleUtil';

//All color and font related changes here. The layout will be in .scss file

const getSkin = (theme) => {
    const skin = theme.globalProfiles.palette;
    const myTypography = typography(theme);

    return StyleSheet.create({
        text: {
            ...myTypography.body1,
            fontSize: '8px',
            textTransform: 'uppercase',
            fontWeight: '600',
            color: skin.white
        },
        icontext: {
            marginBottom: '2px'
        },
        value: {
            ...myTypography.body2,
            lineHeight: '14px',
            fontWeight: 'bold',
            color: skin.white
        }
    });
}

export default getSkin;
